import { render, staticRenderFns } from "./Affiliates.vue?vue&type=template&id=53b340a8&scoped=true&"
import script from "./Affiliates.vue?vue&type=script&lang=js&"
export * from "./Affiliates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b340a8",
  null
  
)

export default component.exports